export default function readCookie(n) {
  if (typeof document === "undefined") {
    return null
  }
  return (document.cookie.split(/;\s*/).find((c) => c.startsWith(`${n}=`)) || "").slice(n.length + 1) || undefined
}
